export enum VideoStatusEnum {
  TO_VALIDATE = 0,
  VALIDATED = 1,
  INVALIDATED = 2,
  DRAFT = 3,
}
